module.exports = __webpack_public_path__ + "img/banner03_01-02.b79f28aa.png";